<template>
  <v-container>
    <!------------SEARCH FORM--------------------------------------------------->
    <!-- <WarehouseSearchForm @searchApparels="searchApparels" :itemsData="itemsData" @openDialog="openCreateNewDialog"></WarehouseSearchForm> -->
    <v-row>
      <v-col cols="auto" class="py-0">
        <v-text-field
          v-model="location"
          label="Location"
          :rules="[rules.required]"
          outlined
          dense
          clearable
          color="accent"
        />
      </v-col>
      <v-col cols="auto" class="py-0">
        <v-checkbox
          v-model="rememberLocation"
          label="Remember location"
          color="accent"
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-row v-if="location">
      <v-col cols="auto" class="py-0">
        <v-btn-toggle v-model="types" color="secondary" dense>
          <v-btn> Apparel </v-btn>
          <v-btn> Decor </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <template v-if="selectedType != '' && location && !skuSearch">
      <v-row class="pt-2">
        <v-col cols="12" sm="2" class="py-0">
          <v-text-field
            v-model="barcodeSearch"
            label="Barcode"
            outlined
            dense
            clearable
            color="accent"
          />
        </v-col>
        <v-col cols="12" sm="2" class="py-0">
          <v-text-field
            v-model="styleNameSearch"
            label="Style name"
            outlined
            dense
            clearable
            color="accent"
          />
        </v-col>
        <v-col cols="12" sm="2" class="py-0">
          <v-text-field
            v-model="styleCodeSearch"
            label="Style code"
            outlined
            dense
            clearable
            color="accent"
          />
        </v-col>
        <v-col cols="12" sm="2" class="py-0">
          <v-text-field
            v-model="manufacturColorSearch"
            label="Manufacturer color"
            outlined
            dense
            clearable
            color="accent"
          />
        </v-col>
        <v-col cols="12" sm="1" class="py-0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="basic_secondary"
                height="40px"
                @click="resetFields"
                ><v-icon color="app">mdi-refresh</v-icon></v-btn
              >
            </template>
            <span
              >Refresh Barcode, Style name, Style code Manufacturer color, SKU
              fields and table data</span
            >
          </v-tooltip>
        </v-col>
      </v-row>
    </template>

    <template
      v-if="
        selectedType != '' &&
        location &&
        !barcodeSearch &&
        !styleNameSearch &&
        !styleCodeSearch &&
        !manufacturColorSearch
      "
    >
      <v-row class="my-0" v-if="!skuSearch">
        <v-col cols="12" sm="2" class="py-0 ml-1">
          <span class="text-body-1">OR</span>
        </v-col></v-row
      >

      <v-row
        v-if="selectedType != '' && location"
        :class="skuSearch ? 'pt-4' : ''"
      >
        <v-col cols="12" sm="2" class="py-0">
          <v-text-field
            v-model="skuSearch"
            label="SKU"
            outlined
            dense
            clearable
            color="accent"
          />
        </v-col>
        <v-col cols="12" sm="1" class="py-0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="basic_secondary"
                height="40px"
                @click="resetFields"
                ><v-icon color="app">mdi-refresh</v-icon></v-btn
              >
            </template>
            <span
              >Refresh Barcode, Style name, Style code Manufacturer color, SKU
              fields and table data</span
            >
          </v-tooltip>
        </v-col>
      </v-row>
    </template>

    <v-row justify="center" class="my-0">
      <v-col cols="auto">
        <v-btn-toggle>
          <v-btn
            outlined
            @click="trySearch"
            small
            v-if="selectedType == 'Apparel'"
            :loading="loadingSearch"
          >
            Search apparel
            <v-icon right style="margin: 5px"> mdi-magnify </v-icon>
          </v-btn>
          <v-btn
            outlined
            @click="trySearch"
            small
            v-if="selectedType == 'Decor'"
            :loading="loadingSearch"
          >
            Search decor
            <v-icon right style="margin: 5px"> mdi-magnify </v-icon>
          </v-btn>
          <v-btn
            outlined
            @click="addNewProduct"
            color="red"
            small
            v-if="
              (selectedType == 'Decor' || selectedType == 'Apparel') &&
              itemsData.length === 0 &&
              !barcodeSearch &&
              !styleNameSearch &&
              !styleCodeSearch &&
              !manufacturColorSearch &&
              !skuSearch
            "
          >
            No information for search
            <v-icon right style="margin: 5px"> mdi-cancel </v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
      
      <!-- Bulk Import Button -->
      <v-col cols="auto" v-if="selectedType != '' && location">
        <v-btn
          outlined
          color="primary"
          small
          @click="showBulkImportDialog = true"
        >
          Bulk Import
          <v-icon right style="margin: 5px">mdi-file-excel</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!--------------------------------------------------------------------------->

    <v-divider class="my-4"></v-divider>

    <ProductDialog
      v-if="showProductForm"
      :product="product"
      :title="title"
      :type="type"
      :fillDynamic="false"
      ref="dialog"
      :excludeKeys="excludeKeys"
      @closeDialog="closeDialog"
      @closedStatusDialog="closedStatusInProduct"
    ></ProductDialog>

    <!------------------------- BULK IMPORT DIALOG --------------------------->
    <v-dialog
      v-model="showBulkImportDialog"
      max-width="1200px"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="text-h5">
          <v-icon left color="primary">mdi-file-excel</v-icon>
          Bulk Import Items
          <v-spacer />
          <v-btn
            icon
            @click="showBulkImportDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="pa-0">
          <BulkImportComponent
            :location="location"
            :selectedType="selectedType"
            @importCompleted="onBulkImportCompleted"
            @closeDialog="showBulkImportDialog = false"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-------------------------------------------------------------------------->

    <!--------------------------RETRIEVED DATA TABLE------------------------------>
    <v-data-table
      v-if="retrieved"
      :headers="headers"
      :items="itemsData"
      :items-per-page="5"
      item-key="SKU"
      class="elevation-1"
      show-expand
      :expanded.sync="expanded"
      :loading="isLoading"
      loading-text="Loading... Please wait"
      group-by="ParentDBID"
      :single-expand="true"
      hide-default-footer
      disable-pagination
      hide-default-header
      height="65vh"
      fixed-header
      :calculate-widths="true"
    >
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th class="footer basic--text" v-for="(h, i) in headers" :key="i">
              <span>{{ h.text.toUpperCase() }}</span>
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:[`group.header`]="{ items, isOpen, toggle }">
        <th
          colspan="10"
          :style="$vuetify.theme.dark ? '' : 'background-color: #bbdefb'"
        >
          <v-icon @click="toggle"
            >{{ isOpen ? "mdi-minus" : "mdi-plus" }}
          </v-icon>
          {{ items[0].Category }}
        </th>
        <td
          colspan="4"
          :style="$vuetify.theme.dark ? '' : 'background-color: #bbdefb'"
        >
          <v-btn color="success" outlined @click="addVariation(items[0])">
            Add variation
          </v-btn>
        </td>
      </template>

      <template v-slot:[`item.add`]="{ item }">
        <tr>
          <td style="width: 70px">
            <v-text-field
              v-model="item.add"
              type="number"
              min="1"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.maxRule, rules.required]"
              @input="checkDisabledButtons(item.add, item.SKU)"
            >
            </v-text-field>
          </td>
        </tr>
      </template>
      <template v-slot:[`item.Size`]="{ item }">
        <tr>
          <td v-if="item.Size !== undefined">
            {{ Object.values(item.Size)[0] }}
          </td>
        </tr>
      </template>
      <template v-slot:[`item.Photos`]="{ item }">
        <tr>
          <td v-if="!item.Photos">NO PHOTO</td>
          <td v-else>
            <v-img max-width="100px" :src="item.Photos[0]"></v-img>
          </td>
        </tr>
      </template>
      <template v-slot:[`item.Barcode`]="{ item }">
        <tr>
          <td v-if="item.Barcode == barcodeSearch">
            <v-chip color="secondary" small>
              <span>{{ item.Barcode }}</span>
            </v-chip>
          </td>
          <td v-else>
            {{ item.Barcode }}
          </td>
        </tr>
      </template>
      <template v-slot:[`item.StyleName`]="{ item }">
        <tr>
          <td v-if="item.StyleName == styleNameSearch">
            <v-chip color="secondary" small>
              <span>{{ item.StyleName }}</span>
            </v-chip>
          </td>
          <td v-else>
            {{ item.StyleName }}
          </td>
        </tr>
      </template>
      <template v-slot:[`item.StyleCode`]="{ item }">
        <tr>
          <td v-if="item.StyleCode == styleCodeSearch">
            <v-chip color="secondary" small>
              <span>{{ item.StyleCode }}</span>
            </v-chip>
          </td>
          <td v-else>
            {{ item.StyleCode }}
          </td>
        </tr>
      </template>
      <template v-slot:[`item.ManufacturerColor`]="{ item }">
        <tr>
          <td v-if="item.ManufacturerColor == manufacturColorSearch">
            <v-chip color="secondary" small>
              <span>{{ item.ManufacturerColor }}</span>
            </v-chip>
          </td>
          <td v-else>
            {{ item.ManufacturerColor }}
          </td>
        </tr>
      </template>
      <template v-slot:[`item.SKU`]="{ item }">
        <tr>
          <td v-if="item.SKU == skuSearch">
            <v-chip color="secondary" small>
              <span>{{ item.SKU }}</span>
            </v-chip>
          </td>
          <td v-else>
            {{ item.SKU }}
          </td>
        </tr>
      </template>
      <template v-slot:[`item.Quantity`]="{ item }">
        <v-chip small :color="item.Quantity < 1 ? 'grey' : 'green'" dark>
          {{ item.Quantity }}
        </v-chip>
      </template>
      <template v-slot:[`item.updateQuantity`]="{ item }">
        <v-btn
          color="error"
          outlined
          v-if="undoBtnSkus.includes(item.SKU)"
          style="width: 80px; margin: 5px"
          :id="'undo_' + item.SKU"
          @click="undoUpdateQuantity(item.SKU, item.add)"
          :disabled="disabledBtnSkus.includes(item.SKU)"
        >
          Undo
          <v-icon right style="margin: 2px" class="icon_style">
            mdi-minus-circle-outline
          </v-icon>
        </v-btn>
        <!-----------BUTTON WHICH INCREASES PRODUCT VARIATION QUANTITY------------------->
        <v-btn
          color="success"
          outlined
          v-if="showAdd(item.SKU)"
          style="width: 20px"
          :id="'add_' + item.SKU"
          @click="updateQuantity(item.SKU, item.add)"
          :disabled="disabledBtnSkus.includes(item.SKU)"
        >
          Add
          <v-icon right style="margin: 2px" class="icon_style">
            mdi-plus-circle-outline
          </v-icon>
        </v-btn>
        <!----------------------------------------------------------------------------------->
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              size="40"
              @click="openHistory(item)"
              color="accent"
              >mdi-eye-circle</v-icon
            >
          </template>
          <span>View product history</span>
        </v-tooltip>
      </template>
      <!------------------------ADDITIONAL INFO ABOUT TABLE ITEM---------------------------->
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <ProductInfo :product="item"></ProductInfo>
        </td>
      </template>
      <!--------------------------------------------------------------------------->
    </v-data-table>
    <!--------------------------------------------------------------------------->

    <!--------------------------NO RESULTS ALERT BOX----------------------------->
    <v-alert
      class="py-1 my-0"
      v-if="searchFailed"
      type="error"
      dark
      icon="mdi-message-alert"
      border="right"
      dense
    >
      <v-row align="center">
        <v-col cols="auto" class="text-center">
          No results matching your values was found. Add a new product or search
          again.
        </v-col>
        <v-spacer></v-spacer>

        <v-col cols="auto">
          <v-btn outlined color="white" @click="addNewProduct" small>
            Add new product
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <!--------------------------------------------------------------------------->
    <br />
    <!--------------------ADD NEW PRODUCT BUTTON------------------->
    <v-row justify="center">
      <v-col cols="auto">
        <v-btn
          outlined
          color="success"
          v-if="showAddNew"
          @click="addNewProduct"
          small
        >
          Add new product
        </v-btn>
      </v-col>
    </v-row>
    <!------------------------------------------------------------------------------->
    <!-------------------RED SNACKBAR, IF FORM IS FILLED INCORRECTLY----------------->
    <v-snackbar top v-model="snackbar" color="#FF3232" class="white--text">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <!------------------------------------------------------------------------------->

    <!-----------------STATUS DIALOG, WHEN TRYING TO CREATE PRODUCT------------------>
    <v-dialog persistent v-model="statusDialog" width="unset" elevation-3>
      <status-info
        :responseMessage="responseMessage"
        :filename="filename"
        :pending="pending"
        @close="closeStatusDialog"
        :textColor="textColor"
      ></status-info>
    </v-dialog>
    <!---------------------------------------------------------------------------------->

    <!-----------------STATUS DIALOG, WHEN TRYING TO UPDATE QUANTITY-------------------->
    <v-dialog persistent v-model="statusDialogQuantity" width="unset">
      <status-info
        :responseMessage="responseMessage"
        :filename="filename"
        :pending="pending"
        :textColor="textColor"
        @close="closeStatusQuantity"
      ></status-info>
    </v-dialog>
    <!---------------------------------------------------------------------------------->

    <!-----------------IF SERVER IS COMPLETELY DOWN--------------------------------------->
    <status-info
      v-if="failed && filename !== ''"
      :responseMessage="responseMessage"
      :filename="filename"
    ></status-info>
    <!----------------------------------------------------------------------------------->

    <ProductHistoryDialog
      :product="productForHistory"
      ref="productHistoryDialog"
    ></ProductHistoryDialog>
  </v-container>
</template>

<script>
import StatusInfo from "../organisms/StatusInfo";
import ProductDialog from "../ProductDialog/ProductDialog.vue";
import ProductInfo from "../organisms/ProductInfo.vue";
import ProductHistoryDialog from "../Descriptions/ProductHistoryDialog.vue";
import BulkImportComponent from "./BulkImportComponent.vue"; // Import your bulk import component

export default {
  name: "ItemSearch",
  components: {
    StatusInfo,
    ProductDialog,
    ProductInfo,
    ProductHistoryDialog,
    BulkImportComponent, // Register the bulk import component
  },
  data: () => ({
    statusDialog: false,
    responseMessage: "",
    filename: "",
    textColor: "basic--text",
    pending: false,
    statusDialogQuantity: false,
    types: ["Apparel", "Decor"],
    barcodeSearch: "",
    styleNameSearch: "",
    styleCodeSearch: "",
    manufacturColorSearch: "",
    skuSearch: "",
    selectedType: "",
    retrieved: false,
    isLoading: false,
    rememberLocation: false,
    location: "",
    searchFailed: false,
    snackbar: false,
    snackbarText: "",
    clicked_type: "",
    clicked_id: "",
    expanded: [],
    itemsData: [],
    headers: [
      { text: "Photo", value: "Photos", class: "px-6 basic--text footer" },
      { text: "SKU", value: "SKU", class: "basic--text footer" },
      { text: "Barcode", value: "Barcode", class: "basic--text footer" },
      { text: "Style name", value: "StyleName", class: "basic--text footer" },
      { text: "Style code", value: "StyleCode", class: "basic--text footer" },
      {
        text: "Manufacturer color",
        value: "ManufacturerColor",
        class: "basic--text footer",
      },
      { text: "Condition", value: "Condition", class: "basic--text footer" },
      { text: "Quantity left", value: "Quantity", class: "basic--text footer" },
      {
        text: "Size",
        value: "Size",
        class: "basic--text footer",
        with: "100px",
      },
      { text: "", value: "updateQuantity", class: "basic--text footer" },
      { text: "Update quantity", value: "add", class: "basic--text footer" },
      {
        text: "history",
        value: "actions",
        class: "basic--text footer",
      },
    ],
    rules: {
      required: (value) => !!value || "Field is required.",
      maxRule: (value) => value > 0 || "Value must be valid!",
    },
    newSKU: "",
    failed: false,
    foundMatch: false,
    addingNew: false,
    showAddNew: false,
    openedQ: "",
    product: {},
    title: "",
    type: "",
    showProductForm: false,
    excludeKeys: [],
    containerKey: 0,
    loadingSearch: false,
    disabledBtnSkus: [],
    undoBtnSkus: [],
    productForHistory: {},
    showBulkImportDialog: false, // New data property for bulk import dialog
  }),
  watch: {
    types(val) {
      if (val == 0) {
        this.selectedType = "Apparel";
      } else {
        this.selectedType = "Decor";
      }
    },
    selectedType(val) {
      this.selectedType = val;
    },
  },
  mounted() {
    //check if there are location value saved in the local storage
    //and if yes, then fill location field
    if (sessionStorage.getItem("location")) {
      this.location = sessionStorage.getItem("location");
    }
  },
  methods: {
    openHistory(item) {
      this.productForHistory = item;
      this.$refs.productHistoryDialog.showDialog(item);
    },
    trySearch() {
      //if remember location checkBox is checked, then put location to session storage
      if (this.rememberLocation) {
        sessionStorage.setItem("location", this.location);
        sessionStorage.setItem("rememberLocation", this.rememberLocation);
      }
      if (
        !this.barcodeSearch &&
        !this.styleCodeSearch &&
        !this.styleNameSearch &&
        !this.manufacturColorSearch &&
        !this.skuSearch
      ) {
        this.snackbarText = "At least one value must be given to proceed!";
        this.snackbar = true;
      } else {
        if (this.skuSearch) {
          this.searchBySku();
        } else {
          this.searchApparels();
        }
      }
    },
    async searchBySku() {
      this.loadingSearch = true;
      this.itemsData = [];
      this.foundMatch = false;
      this.exactMatch = {};
      this.retrieved = false;
      //stop showing add new product button
      this.showAddNew = false;
      try {
        const response = await this.$store.dispatch("searchSKU", {
          SKU: this.skuSearch.trim(),
        });

        //if search successful
        if (response.status == 200) {
          this.loadingSearch = false;
          this.searchFailed = false;
          this.retrieved = true;

          this.foundMatch = true;
          this.exactMatch = response.data;
          this.itemsData.push(response.data);

          for (let obj of this.itemsData) {
            obj["add"] = 1;
          }
        }
      } catch (error) {
        this.loadingSearch = false;
        console.log(error);
        this.searchFailed = true;
        this.retrieved = false;

        this.itemsData = [];
      }
    },
    searchApparels() {
      this.loadingSearch = true;
      //data table loading prop
      this.isLoading = true;
      this.itemsData = [];
      this.foundMatch = false;
      this.exactMatch = {};
      this.retrieved = false;
      let responseData = "";
      //stop showing add new product button
      this.showAddNew = false;
      // searching products in server
      this.$store
        .dispatch("searchProducts", {
          Type: this.selectedType,
          Barcode: this.barcodeSearch,
          StyleCode: this.styleCodeSearch,
          StyleName: this.styleNameSearch,
          ManufacturerColor: this.manufacturColorSearch,
        })
        .then((response) => {
          this.textColor = "basic--text";
          this.isLoading = false;
          responseData = response.data;

          switch (responseData.Condition) {
            case 1:
            case 2:
            case 3:
            case 4:
              this.searchFailed = false;
              this.retrieved = true;
              if (responseData["ExactMatch"] != undefined) {
                this.foundMatch = true;
                this.exactMatch = responseData["ExactMatch"];
                this.itemsData.push(this.exactMatch);
              }

              if (responseData["OtherVariations"] != undefined) {
                for (var obj of response.data["OtherVariations"]) {
                  this.itemsData.push(obj);
                }
              }
              for (obj of this.itemsData) {
                obj["add"] = "1";
              }
              break;
            case 5:
            case 6:
            case 7:
              this.searchFailed = false;
              this.retrieved = true;
              this.itemsData = responseData.Products;
              for (obj of this.itemsData) {
                obj["add"] = "1";
              }
              this.showAddNew = true;
              break;
            case 8:
              this.searchFailed = true;
              this.retrieved = false;

              this.itemsData = [];

              break;
          }
          this.loadingSearch = false;
        })
        .catch((error) => {
          console.log(error);
          this.loadingSearch = false;
          this.textColor = "red--text";
          this.isLoading = false;
          this.statusDialog = true;
          if (error.response) {
            this.showErrors(error.response.status, error.response.data);
          } else {
            // anything else
            this.filename = "feeling_blue.svg";
            this.responseMessage =
              "SORRY... Something went wrong when trying to search products.";
          }
        });
    },
    addVariation(item) {
      //fill these fields from search form if it is not filled from variation:

      item["Barcode"] = this.barcodeSearch != "" ? this.barcodeSearch : "";

      if (!item["StyleName"]) {
        item["StyleName"] =
          this.styleNameSearch != "" ? this.styleNameSearch : "";
      }

      if (!item["StyleCode"]) {
        item["StyleCode"] =
          this.styleCodeSearch != "" ? this.styleCodeSearch : "";
      }
      if (!item["ManufacturerColor"]) {
        item["ManufacturerColor"] =
          this.manufacturColorSearch != "" ? this.manufacturColorSearch : "";
      }

      //set product type from selected type in  search form
      item["Type"] = this.selectedType;
      //set location value from search form
      item["Location"] = this.location;

      this.product = item;
      this.title = "Add new variation";
      this.type = "registration";
      this.excludeKeys = [
        "RealColor",
        "Condition",
        "ConditionDescription",
        "Defect",
        "ManufacturerColor",
        "Notes",
      ];

      this.showProductForm = true;
    },
    addNewProduct() {
      let item = {};
      item["Barcode"] = this.barcodeSearch != "" ? this.barcodeSearch : "";

      item["StyleName"] =
        this.styleNameSearch != "" ? this.styleNameSearch : "";

      item["StyleCode"] =
        this.styleCodeSearch != "" ? this.styleCodeSearch : "";

      item["ManufacturerColor"] =
        this.manufacturColorSearch != "" ? this.manufacturColorSearch : "";

      item["Type"] = this.selectedType;
      item["Location"] = this.location;

      this.product = {};

      this.product = item;
      this.title = "Add new product";
      this.type = "registration";

      this.excludeKeys = [];
      this.showProductForm = true;
    },
    closeDialog() {
      this.showProductForm = false;
    },
    toggle(sku) {
      this.itemsData.forEach((item) => {
        if (item.SKU === sku) {
          item.hide = !item.hide;
        }
      });
    },
    closeStatusDialog() {
      this.statusDialog = false;
      this.textColor = "basic--text";
      this.searchApparels();
    },
    resetFields() {
      this.barcodeSearch = "";
      this.styleNameSearch = "";
      this.styleCodeSearch = "";
      this.manufacturColorSearch = "";
      this.skuSearch = "";
      //data table loading prop
      this.isLoading = true;
      this.itemsData = [];
      this.foundMatch = false;
      this.exactMatch = {};
      this.retrieved = false;
      this.showAddNew = false;
      this.searchFailed = false;
    },
    //show add button
    showAdd(sku) {
      if (!this.disabledBtnSkus.includes(sku)) {
        return true;
      }
      return false;
    },
    //show undo button
    showUndo(sku) {
      if (this.clicked_type == "add" && this.clicked_id == sku) {
        return true;
      }
      return false;
    },
    checkDisabledButtons(q, itemSku) {
      if (!q || q < 1) {
        if (!this.disabledBtnSkus.includes(itemSku))
          this.disabledBtnSkus.push(itemSku);
      } else {
        if (this.disabledBtnSkus.includes(itemSku)) {
          for (var i = 0; i < this.disabledBtnSkus.length; i++) {
            if (this.disabledBtnSkus[i] === itemSku) {
              this.disabledBtnSkus.splice(i, 1);
            }
          }
        }
      }
    },
    updateQuantity(itemSku, q) {
      this.pending = true;
      this.statusDialogQuantity = true;

      this.$store
        .dispatch("updateQuantity", {
          SKU: itemSku,
          BinRack: this.location,
          Quantity: parseInt(q),
        })
        .then(() => {
          this.textColor = "basic--text";
          this.clicked_type = "add";
          this.clicked_id = itemSku;
          if (!this.undoBtnSkus.includes(itemSku)) {
            this.undoBtnSkus.push(itemSku);
          }

          this.pending = false;
          this.filename = "high_five.svg";
          this.responseMessage =
            "Quantity updated successfully! You can cancel quantity update by clicking UNDO button.";
          this.trySearch();
        })
        .catch((error) => {
          this.textColor = "red--text";
          this.pending = false;
          this.responseMessage = error.response.data;
          if (error.response) {
            this.showErrors(error.response.status, error.response.data);
          } else {
            // anything else
            this.filename = "feeling_blue.svg";
            this.responseMessage = "SORRY... Something went wrong.";
          }
        });
    },

    undoUpdateQuantity(itemSku, q) {
      this.pending = true;
      this.statusDialogQuantity = true;

      this.$store
        .dispatch("undoUpdateQuantity", {
          SKU: itemSku,
          BinRack: this.location,
          Quantity: parseInt(q),
        })
        .then(() => {
          this.textColor = "basic--text";
          this.clicked_type = "";
          this.clicked_id = "";
          for (var i = 0; i < this.undoBtnSkus.length; i++) {
            if (this.undoBtnSkus[i] === itemSku) {
              this.undoBtnSkus.splice(i, 1);
            }
          }
          this.pending = false;
          this.filename = "high_five.svg";
          this.responseMessage = "You canceled quantity update.";
          this.trySearch();
        })
        .catch((error) => {
          this.textColor = "red--text";
          this.pending = false;
          this.responseMessage = error.response.data;
          if (error.response) {
            this.showErrors(error.response.status, error.response.data);
          } else {
            // anything else
            this.filename = "feeling_blue.svg";
            this.responseMessage = "SORRY... Something went wrong.";
          }
        });
    },
    //emitted from productDialog component when closing status dialog
    closedStatusInProduct() {
      this.showProductForm = false;
      this.trySearch();
    },
    barColorChange(item) {
      if (item.Barcode === this.barcodeSearch) {
        return true;
      }
      return false;
    },
    nameColorChange(item) {
      if (item.StyleName === this.styleNameSearch) {
        return true;
      }
      return false;
    },
    codeColorChange(item) {
      if (item.StyleCode === this.styleCodeSearch) {
        return true;
      }
      return false;
    },
    manufacturColorChange(item) {
      if (item.ManufacturerColor === this.manufacturColorSearch) {
        return true;
      }
      return false;
    },
    reset() {
      this.$router.go();
    },
    closeStatusQuantity() {
      this.statusDialogQuantity = false;
    },
    showErrors(status, message) {
      // client received an error response (5xx, 4xx)
      this.responseMessage = message;
      switch (status) {
        case 400:
          this.filename = "empty.png";
          break;
        case 401:
          //clear local storage, push to login
          localStorage.clear();
          this.$router.push("login");
          break;
        case 403:
          this.filename = "403_forbidden.png";
          break;
        case 404:
          this.responseMessage = "Bad request. Please contact TECH team.";
          this.filename = "void.png";
          break;
        case 500:
          this.filename = "server_down.png";
      }
    },
    // NEW METHOD: Handle bulk import completion
 // Replace the onBulkImportCompleted method in ItemSearch.vue with this:

onBulkImportCompleted(results) {
  console.log('Bulk import completed with results:', results);
  
  // Check the actual results and show appropriate message
  if (results.wasSuccessful) {
    // All items succeeded
    this.snackbarText = `Bulk import completed successfully! ${results.successful} items imported.`;
    this.snackbar = true;
    this.showBulkImportDialog = false;
    
    // Refresh the search results to show newly imported items
    if (this.retrieved) {
      this.trySearch();
    }
  } else if (results.wasPartialSuccess) {
    // Some succeeded, some failed
    this.snackbarText = `Import partially complete: ${results.successful} succeeded, ${results.failed} failed. Check the failed items list.`;
    this.snackbar = true;
    // Don't close dialog automatically for partial success - let user review failed items
    
    // Refresh search to show successfully imported items
    if (this.retrieved) {
      this.trySearch();
    }
  } else {
    // All failed
    this.snackbarText = `Import failed: All ${results.failed} items failed to import. Please fix the errors and try again.`;
    this.snackbar = true;
    // Don't close dialog - keep it open so user can see errors and fix them
  }
}
  },
};
</script>
<style>
.does-match {
  color: #127897;
  font-weight: bold;
}
.wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, 1fr);
  gap: 10px;
  grid-auto-rows: minmax(100px, auto);
}

.style-1 {
  background-color: #c8e6c9;
}
</style>